import { BrowserRouter, useRoutes, Navigate } from "react-router-dom";
import { patientRoutes } from "./patientRoutes";
import { adminRoutes } from "./adminRoutes";
import { docteurRoutes } from "./docteurRoutes";
import { secretaryRoutes } from "./secretaryRoutes";

function RouterContent() {
  const onLoginSuccess = (token: string) => {
    localStorage.setItem("token", token);
  };

  const routes = [
    {
      path: "/",
      element: <Navigate to="/login" replace />,
    },
    ...patientRoutes(onLoginSuccess),
    ...adminRoutes(onLoginSuccess),
    ...docteurRoutes(onLoginSuccess),
    ...secretaryRoutes(onLoginSuccess),

    { path: "*", element: <Navigate to="/login" replace /> },
  ];

  const element = useRoutes(routes);
  return element;
}

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <RouterContent />
    </BrowserRouter>
  );
}